import router from "../../../router";
import SignalContent from "../signal_content";
import { makeSensorData } from "./make_signallamp_sensor_data";
import { SignallampAlertHistoryDataArrayType, SignallampAlertHistoryRawDataType } from "../../../types/types";
export async function makeSignallampAlertHistoryData(self: SignalContent, rawDataSets: SignallampAlertHistoryRawDataType[]) {
  if (self.token === null) {
    return router.push("/signIn");
  }
  try {
    if (!rawDataSets) {
      return [];
    }
    const alertHistoryDataArray: SignallampAlertHistoryDataArrayType[] = [];
    // v-bind:key用のidを作成
    let num: number = 1;
    // 取得したアラート履歴を一度forで回す
    for (const key in rawDataSets) {
      // 1度に2色以上点灯したら複数レコードに分けてpushする
        const durationParams = rawDataSets[key].duration ? rawDataSets[key].duration : "--";
        const timeStamp = makeSensorData(self, rawDataSets[key]);
        alertHistoryDataArray.push({
          id: num,
          timestamp: timeStamp,
          deviceId: rawDataSets[key].device_id,
          location: rawDataSets[key].location,
          duration: durationParams,
          lampColor: rawDataSets[key].alert_color_list,
        });
        num++;
    }
    return alertHistoryDataArray;
  } catch (e) {
    console.error(e);
    alert(self.$t("message.failedToRetrieveAlarmHistory"));
  }
}
